// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  
}


html, body {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}



/* *******************************************************************
SIDEBAR STYLES
******************************************************************** */
:root
{
  /* *******************************************************************
  SIDEBAR CONSTANTS
  ******************************************************************** */
  --sidebar-transition-duration: 0.5s;
}



.divFullSideBar {
    background-color: black;
    
    position: absolute;
    width: 100%;
    height: 100%;
    
  }
  
  .divLeftSideBarOpen {
  
    position: absolute;
    background-color: #090909;
    left: 0%;
    top: 0%;
    width: 20%;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
  }

  .divLeftSideBarOpenUp {
    width: 100%;
    height: 90%;
    
    

  }
  .divLeftSideBarOpenDown {
    width: 100%;
    height: 10%;
    
    text-align: center;
    
    border-style: solid;
    
  }

  .divRightSideBarOpen {
  
    position: absolute;
    background-color: #050505;
    left: 20%;
    top: 0;
    width: 80%;
    height: 100%;
    text-align: center;

    
    border-style: dashed;
    
    
    
    transition-property: left width ;
    transition-duration: var(--sidebar-transition-duration);
    
  }
  
  
  .divLeftSideBarClose {
  
    position: absolute;
    
    left: 0%;
    top: 0%;
    width: 0%;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
  }
  

  .divBottomSideBarClose
  {
    position: absolute;
    display: flex;
    flex-direction: row;
    background-color: transparent;
    left: 0px;
    top: calc(99% - 30px);

    width: calc(100%);
    height: 48px;
    overflow: hidden;

  }

  .divBottomSideBarClose1
  {
      height: 100%;
      background-color: transparent;
      width: 64px;
      overflow: hidden;
      color: white;

  }

.divBottomSideBarClose2
  {
      height: 100%;
      background-color: transparent;
      width: calc(100% - 64px);
      overflow: hidden;
      background-color: transparent;
      
  }


  .divBottomSideBarOpen
  {
    position: absolute;
    background-color: transparent;
    left: 0px;
    top: calc(100% - 112px);

    width: calc(100%);
    height: 192px;
    overflow: hidden;

  }

  
  
  .divRightSideBarClose {
  
    position: absolute;
    background-color: transparent;
    left: 0px;
    top: 0;
    width: 100%;
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform left;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;

    


  }

  .divRightSideBarCloseWithIcon {
  
    position: absolute;
    background-color: transparent;
    left: 0px;
    top: 0;
    width: 100%;
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform left;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;

  }

  
  .divMenuButtonSideBar
  {
    position: absolute;
    left: 0%;
    top: 0%;
    width: 100%;
    height: 64px;
    margin-top: 5px;
    margin-left: 5px;
    -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  
  }
  
  .divContentOpenSideBar
  {
    position: absolute;
    left: 0%;
    top: 95px;
    width: 100%;
    height: 100%;
    border-color: gray;
    border-width: var(--debug-border-width);
    border-style: var(--debug-border-style);
    

  }
  
  /* **************************************************************************
     Menu Items
  ****************************************************************************/   
.catsCatItem
{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;    
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: left;

}
.catScatBorderText
{
  border-width: 1px;
  border-style: solid;
  border-color:gray;
  border-radius: 5px;
  background-color: var(--sidebar-color-selectedbackground);

}
.catScatNoBorderText
{
  border-width: 0px;
}

/* Niveau 1 */

.catSideBarDefaultItem
{
  color: var(--sidebar-color-text);
  margin-top: 20px;
  margin-left: 30px;
}

.catSideBarSelectedItem
{
  color: var(--sidebar-color-selected-text);
  margin-top: 20px;
  margin-left: 30px;
}

.catSideBarDisableItem
{
  color: var(--sidebar-color-disable-text);
  margin-top: 20px;
  margin-left: 30px;
}

/* Niveau 2 */

.scatSideBarDefaultItem
{
  color: var(--sidebar-color-text);
  margin-top: 10px;
  margin-left: 65px;
}

.scatSideBarSelectedItem
{
  color: var(--sidebar-color-selected-text);
  margin-top: 10px;
  margin-left: 65px;
}

.scatSideBarDisableItem
{
  color: var(--sidebar-color-disable-text);
  margin-top: 10px;
  margin-left: 65px;
}


/* bouton ouverture fermeture   */
.MenuBoutonOpenClose
{
  position: absolute;
  top: calc(100% - 32px);
  left: 10px;
  height: 32px;
  width: 32px;
  overflow: hidden;
}


/* Menu Icons Only *****************************************************/

.IconOnlyFullFiv
{
  display: flex;
  flex-direction:row;
  width: 100%;
  overflow: hide;
  

}



.IconOnlyDiv
{
  display: flex;
  flex-direction:row;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
  
  
}

.IconOnlyDiv1
{
  background-color: black;
  
  border-radius: 8px;
  border-color: var(--default-icon-color);
  border-width: 2px;
  border-style: solid;
  display: flex;
  flex-direction:row;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-top: 5px;
  padding-bottom: 10px;
  
  
  
  
}

.IconOnlySideBar
  {
    margin-top: 15px;
    margin-left: 7px;
    margin-right: 7px;
    text-align: center;
    -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    width: 96px;
  
  }
  .IconOnlySelectedSideBar
  {
    border-width: 1px;
    border-style: solid;
    border-color:gray;
    border-radius: 5px;
    background-color: var(--sidebar-color-selectedbackground);
    -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    width: 96px;
    
  }`, "",{"version":3,"sources":["webpack://./src/components/siderbar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;;AAExB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;;;AAIA;;sEAEsE;AACtE;;EAEE;;wEAEsE;EACtE,mCAAmC;AACrC;;;;AAIA;IACI,uBAAuB;;IAEvB,kBAAkB;IAClB,WAAW;IACX,YAAY;;EAEd;;EAEA;;IAEE,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,OAAO;IACP,UAAU;IACV,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;EACzD;;EAEA;IACE,WAAW;IACX,WAAW;;;;EAIb;EACA;IACE,WAAW;IACX,WAAW;;IAEX,kBAAkB;;IAElB,mBAAmB;;EAErB;;EAEA;;IAEE,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,MAAM;IACN,UAAU;IACV,YAAY;IACZ,kBAAkB;;;IAGlB,oBAAoB;;;;IAIpB,gCAAgC;IAChC,uDAAuD;;EAEzD;;;EAGA;;IAEE,kBAAkB;;IAElB,QAAQ;IACR,OAAO;IACP,SAAS;IACT,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;EACzD;;;EAGA;;IAEE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;IACT,qBAAqB;;IAErB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;;EAElB;;EAEA;;MAEI,YAAY;MACZ,6BAA6B;MAC7B,WAAW;MACX,gBAAgB;MAChB,YAAY;;EAEhB;;AAEF;;MAEM,YAAY;MACZ,6BAA6B;MAC7B,wBAAwB;MACxB,gBAAgB;MAChB,6BAA6B;;EAEjC;;;EAGA;;IAEE,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,uBAAuB;;IAEvB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;;EAElB;;;;EAIA;;IAEE,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mCAAmC;IACnC,uDAAuD;IACvD,gBAAgB;;;;;EAKlB;;EAEA;;IAEE,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mCAAmC;IACnC,uDAAuD;IACvD,gBAAgB;;EAElB;;;EAGA;;IAEE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB,EAAE,WAAW,EACf,oBAAoB;IAC3C,iBAAiB,EAAE,oBAAoB;;EAEzC;;EAEA;;IAEE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,uCAAuC;;;EAGzC;;EAEA;;8EAE4E;AAC9E;;EAEE;;YAEU;EACV,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;EACvC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;;AAEvB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yDAAyD;;AAE3D;AACA;;EAEE,iBAAiB;AACnB;;AAEA,aAAa;;AAEb;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,aAAa;;AAEb;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA,iCAAiC;AACjC;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;;AAGA,wEAAwE;;AAExE;;EAEE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,cAAc;;;AAGhB;;;;AAIA;;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;;;AAGb;;AAEA;;EAEE,uBAAuB;;EAEvB,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;;;;;AAKtB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB,EAAE,WAAW,EACf,oBAAoB;IAC3C,iBAAiB,EAAE,oBAAoB;IACvC,WAAW;;EAEb;EACA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yDAAyD;IACzD,yBAAyB,EAAE,WAAW,EACf,oBAAoB;IAC3C,iBAAiB,EAAE,oBAAoB;IACvC,WAAW;;EAEb","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  \n}\n\n\nhtml, body {\n  overflow: hidden;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n\n\n/* *******************************************************************\nSIDEBAR STYLES\n******************************************************************** */\n:root\n{\n  /* *******************************************************************\n  SIDEBAR CONSTANTS\n  ******************************************************************** */\n  --sidebar-transition-duration: 0.5s;\n}\n\n\n\n.divFullSideBar {\n    background-color: black;\n    \n    position: absolute;\n    width: 100%;\n    height: 100%;\n    \n  }\n  \n  .divLeftSideBarOpen {\n  \n    position: absolute;\n    background-color: #090909;\n    left: 0%;\n    top: 0%;\n    width: 20%;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n  }\n\n  .divLeftSideBarOpenUp {\n    width: 100%;\n    height: 90%;\n    \n    \n\n  }\n  .divLeftSideBarOpenDown {\n    width: 100%;\n    height: 10%;\n    \n    text-align: center;\n    \n    border-style: solid;\n    \n  }\n\n  .divRightSideBarOpen {\n  \n    position: absolute;\n    background-color: #050505;\n    left: 20%;\n    top: 0;\n    width: 80%;\n    height: 100%;\n    text-align: center;\n\n    \n    border-style: dashed;\n    \n    \n    \n    transition-property: left width ;\n    transition-duration: var(--sidebar-transition-duration);\n    \n  }\n  \n  \n  .divLeftSideBarClose {\n  \n    position: absolute;\n    \n    left: 0%;\n    top: 0%;\n    width: 0%;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n  }\n  \n\n  .divBottomSideBarClose\n  {\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n    background-color: transparent;\n    left: 0px;\n    top: calc(99% - 30px);\n\n    width: calc(100%);\n    height: 48px;\n    overflow: hidden;\n\n  }\n\n  .divBottomSideBarClose1\n  {\n      height: 100%;\n      background-color: transparent;\n      width: 64px;\n      overflow: hidden;\n      color: white;\n\n  }\n\n.divBottomSideBarClose2\n  {\n      height: 100%;\n      background-color: transparent;\n      width: calc(100% - 64px);\n      overflow: hidden;\n      background-color: transparent;\n      \n  }\n\n\n  .divBottomSideBarOpen\n  {\n    position: absolute;\n    background-color: transparent;\n    left: 0px;\n    top: calc(100% - 112px);\n\n    width: calc(100%);\n    height: 192px;\n    overflow: hidden;\n\n  }\n\n  \n  \n  .divRightSideBarClose {\n  \n    position: absolute;\n    background-color: transparent;\n    left: 0px;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform left;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n\n    \n\n\n  }\n\n  .divRightSideBarCloseWithIcon {\n  \n    position: absolute;\n    background-color: transparent;\n    left: 0px;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform left;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n\n  }\n\n  \n  .divMenuButtonSideBar\n  {\n    position: absolute;\n    left: 0%;\n    top: 0%;\n    width: 100%;\n    height: 64px;\n    margin-top: 5px;\n    margin-left: 5px;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none; /* Standard syntax */\n  \n  }\n  \n  .divContentOpenSideBar\n  {\n    position: absolute;\n    left: 0%;\n    top: 95px;\n    width: 100%;\n    height: 100%;\n    border-color: gray;\n    border-width: var(--debug-border-width);\n    border-style: var(--debug-border-style);\n    \n\n  }\n  \n  /* **************************************************************************\n     Menu Items\n  ****************************************************************************/   \n.catsCatItem\n{\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n  sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;    \n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n\n}\n.catScatBorderText\n{\n  border-width: 1px;\n  border-style: solid;\n  border-color:gray;\n  border-radius: 5px;\n  background-color: var(--sidebar-color-selectedbackground);\n\n}\n.catScatNoBorderText\n{\n  border-width: 0px;\n}\n\n/* Niveau 1 */\n\n.catSideBarDefaultItem\n{\n  color: var(--sidebar-color-text);\n  margin-top: 20px;\n  margin-left: 30px;\n}\n\n.catSideBarSelectedItem\n{\n  color: var(--sidebar-color-selected-text);\n  margin-top: 20px;\n  margin-left: 30px;\n}\n\n.catSideBarDisableItem\n{\n  color: var(--sidebar-color-disable-text);\n  margin-top: 20px;\n  margin-left: 30px;\n}\n\n/* Niveau 2 */\n\n.scatSideBarDefaultItem\n{\n  color: var(--sidebar-color-text);\n  margin-top: 10px;\n  margin-left: 65px;\n}\n\n.scatSideBarSelectedItem\n{\n  color: var(--sidebar-color-selected-text);\n  margin-top: 10px;\n  margin-left: 65px;\n}\n\n.scatSideBarDisableItem\n{\n  color: var(--sidebar-color-disable-text);\n  margin-top: 10px;\n  margin-left: 65px;\n}\n\n\n/* bouton ouverture fermeture   */\n.MenuBoutonOpenClose\n{\n  position: absolute;\n  top: calc(100% - 32px);\n  left: 10px;\n  height: 32px;\n  width: 32px;\n  overflow: hidden;\n}\n\n\n/* Menu Icons Only *****************************************************/\n\n.IconOnlyFullFiv\n{\n  display: flex;\n  flex-direction:row;\n  width: 100%;\n  overflow: hide;\n  \n\n}\n\n\n\n.IconOnlyDiv\n{\n  display: flex;\n  flex-direction:row;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  width: 100%;\n  \n  \n}\n\n.IconOnlyDiv1\n{\n  background-color: black;\n  \n  border-radius: 8px;\n  border-color: var(--default-icon-color);\n  border-width: 2px;\n  border-style: solid;\n  display: flex;\n  flex-direction:row;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  padding-top: 5px;\n  padding-bottom: 10px;\n  \n  \n  \n  \n}\n\n.IconOnlySideBar\n  {\n    margin-top: 15px;\n    margin-left: 7px;\n    margin-right: 7px;\n    text-align: center;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none; /* Standard syntax */\n    width: 96px;\n  \n  }\n  .IconOnlySelectedSideBar\n  {\n    border-width: 1px;\n    border-style: solid;\n    border-color:gray;\n    border-radius: 5px;\n    background-color: var(--sidebar-color-selectedbackground);\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none; /* Standard syntax */\n    width: 96px;\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
